import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination"
import PropTypes from 'prop-types';

import SwiperCore, {
    Pagination
} from 'swiper';

SwiperCore.use([Pagination]);


const defaultImages = [
    '/assets/img/room1_img.png',
    '/assets/img/room1_img.png',
    '/assets/img/room1_img.png',
    '/assets/img/room1_img.png',
    '/assets/img/room1_img.png'
];

export const SliderImages = ({ items = defaultImages, onclickitem }) => {

    const handleClickItem = (e) => {
        onclickitem(e);
    }

    return (

        <>
            <Swiper
                slidesPerView={'auto'}
                pagination={{
                    clickable: true
                }}
                touchStartForcePreventDefault={false}
                className="sliderRoomImages"
                onClick={handleClickItem}
            >
                {
                    items.map((item, index) => {
                        return (
                            <SwiperSlide className="swiper-slide-badges" key={'slide_' + index}>
                                <img className="shadow" src={item} alt={"Imagen generada " + (index + 1)} />
                            </SwiperSlide>
                        )
                    })
                }

            </Swiper>
        </>

    );
};


SliderImages.propTypes = {
    items: PropTypes.array,
    onclickitem: PropTypes.func
};